import React, { useCallback, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as BsIcons from "react-icons/bs";
import * as MdIcons from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import * as actionType from "../../constants/actionTypes";
import "./Navbar.css";
import { IconContext } from "react-icons";
import { useDispatch } from "react-redux";
import { tokenExpired } from "../token";
import UNAUTHORIZED from "../UNAUTHORIZED";

function Sidebar() {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [sidebar, setSidebar] = useState(false);
  const [dropMenuInv, setDropMenuInv] = useState(false);
  const [dropMenuAud, setDropMenuAud] = useState(false);
  const [dropMenuScore, setDropMenuScore] = useState(false);
  const [dropMenuMOHE, setDropMenuMOHE] = useState(false);

  const showSidebar = () => setSidebar(!sidebar);
  const showDropMenuInv = () => setDropMenuInv(!dropMenuInv);
  const showDropMenuAud = () => setDropMenuAud(!dropMenuAud);
  const showDropMenuScore = () => setDropMenuScore(!dropMenuScore);
  const showDropMenuMOHE = () => setDropMenuMOHE(!dropMenuMOHE);

  const logout = useCallback(() => {
    dispatch({ type: actionType.LOGOUT });
    navigate("/");
  }, [dispatch, navigate]);

  useEffect(() => {
    tokenExpired(user, logout, navigate);
    setUser((user) => user);
  }, [location, user, navigate, logout]);

  return (
    <div className="mb-10">
      {!user ? (
        <UNAUTHORIZED />
      ) : (
        <div>
          <IconContext.Provider value={{ color: "#fff" }}>
            <div className="navbar">
              <div className="menu-bars cursor-pointer">
                <FaIcons.FaBars onClick={showSidebar} />
              </div>
              <div className="px-6 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm uppercase shrink-0 shadow">
                  {user?.value?.[0]?.username?.charAt(0) || "?"}
                </div>
                <div className="hidden sm:block">
                  <p className="text-white text-sm font-semibold leading-tight">{user?.value?.[0]?.username}</p>
                  <p className="text-indigo-300 text-xs capitalize leading-tight">{user?.value?.[0]?.role}</p>
                </div>
                <button
                  onClick={logout}
                  className="ml-1 flex items-center gap-1.5 text-xs bg-red-500/15 hover:bg-red-600 border border-red-500/40 text-red-400 hover:text-white px-3 py-1.5 rounded-lg transition-all duration-200 font-medium"
                >
                  <FiLogOut size={13} /> Logout
                </button>
              </div>
            </div>
            <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
              <div className="overflow-scroll w-full">
                <ul className="nav-menu-items">
                  <li className="navbar-toggle" onClick={showSidebar}>
                    <div className="menu-bars cursor-pointer">
                      <AiIcons.AiOutlineClose />
                    </div>
                  </li>
                  {user.value[0].role !== "moderator" && (
                  <li className="nav-text" onClick={showSidebar}>
                    <NavLink to="/main">
                      <AiIcons.AiFillHome />
                      <span>Main</span>
                    </NavLink>
                  </li>
                  )}
                  {/* Overview: admin and auditor */}
                  {["admin", "auditor"].includes(user.value[0].role) ? (
                    <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/main/overview">
                        <IoIcons.IoIosPaper />
                        <span>Overview</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                  {/* Table: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/main/table">
                        <BsIcons.BsTable />
                        <span>Table</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                  {/* Global Actions: admin only */}
                  {/* {user.value[0].role === "admin" ? (
                    <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/main/actions">
                        <IoIcons.IoMdPeople />
                        <span>Global Actions</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )} */}
                  {user.value[0].role === "admin" ? (
                    <>
                      <li className="nav-text" onClick={showSidebar}>
                        <NavLink to="/main/add_user">
                          <FaIcons.FaUser />
                          <span>Manage Users</span>
                        </NavLink>
                      </li>
                    </>
                  ) : (
                    ""
                  )}
                  {/* Moderator: only search page */}
                  {user.value[0].role === "moderator" ? (
                    <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/main/moderator">
                        <FaIcons.FaSearch />
                        <span>Student Lookup</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                  )}
                  {/* Auditing: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <>
                      <li className="nav-text" onClick={showDropMenuAud}>
                        <div className="drop-click">
                          <FaIcons.FaEdit />
                          <span>Auditing</span>
                        </div>
                      </li>
                      {dropMenuAud ? (
                        <div>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/auditing/new">
                              <span>New</span>
                            </NavLink>
                          </li>
                           <li className="nav-text" onClick={showSidebar}>
                              <NavLink to="/main/auditing/pending">
                                <span>Pending</span>
                              </NavLink>
                            </li>
                          {/* Request Edit: admin and auditor only, not agent */}
                          {["admin", "auditor"].includes(user.value[0].role) ? (
                            <li className="nav-text" onClick={showSidebar}>
                              <NavLink to="/main/auditing/request_edit">
                                <span>Request Edit</span>
                              </NavLink>
                            </li>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {/* Invoice: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <>
                      <li className="nav-text" onClick={showDropMenuInv}>
                        <div className="drop-click">
                          <FaIcons.FaFileInvoiceDollar />
                          <span>Invoice</span>
                        </div>
                      </li>
                      {dropMenuInv ? (
                        <div>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/invoice/new">
                              <span>New</span>
                            </NavLink>
                          </li>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/invoice/wait">
                              <span>Invoice Wait</span>
                            </NavLink>
                          </li>
                          {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                            <li className="nav-text" onClick={showSidebar}>
                              <NavLink to="/main/invoice/another_invoice">
                                <span>Another Invoice</span>
                              </NavLink>
                            </li>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {/* Score Handler: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <>
                      <li className="nav-text" onClick={showDropMenuScore}>
                        <div className="drop-click">
                          <MdIcons.MdScore />
                          <span>Score Handler</span>
                        </div>
                      </li>
                      {dropMenuScore ? (
                        <div>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/score/score_validation">
                              <span>Score Validation</span>
                            </NavLink>
                          </li>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/score/new">
                              <span>Score Request</span>
                            </NavLink>
                          </li>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/score/score_pending">
                              <span>Score Pending</span>
                            </NavLink>
                          </li>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}

                  {/* MOHE: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <>
                      <li className="nav-text" onClick={showDropMenuMOHE}>
                        <div className="drop-click">
                          <IoIcons.IoIosDocument />
                          <span>MOHE</span>
                        </div>
                      </li>
                      {dropMenuMOHE ? (
                        <div>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/mohe/mohe_validation">
                              <span>MOHE Validation</span>
                            </NavLink>
                          </li>
                          <li className="nav-text" onClick={showSidebar}>
                            <NavLink to="/main/mohe/new">
                              <span>Sending to MOHE</span>
                            </NavLink>
                          </li>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                  {/* Done: admin, auditor, agent */}
                  {["admin", "auditor", "agent"].includes(user.value[0].role) ? (
                    <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/main/done">
                        <MdIcons.MdOutlineDoneOutline />
                        <span>Done Students</span>
                      </NavLink>
                    </li>
                  ) : (
                    ""
                    )}
                     <li className="nav-text" onClick={showSidebar}>
                      <NavLink to="/form" target="_blank">
                        <MdIcons.MdAddBox />
                        <span>Form Page</span>
                      </NavLink>
                    </li>
                </ul>
              </div>
            </nav>
          </IconContext.Provider>

          <main className={`pt-[70px] pb-5 transition-all duration-[350ms] ${sidebar ? "ml-60 px-4" : "px-4 sm:px-8"}`}>
            <div>
              <Outlet />
            </div>
          </main>
          <div className="footer-style">
            <p>Authentication System &copy; V1.</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Sidebar;
